var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResourcesDropdownIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_5468)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.27738 1.01221H16.4978C17.6507 1.01221 18.5853 1.94678 18.5853 3.09964V16.3201C18.5853 17.4729 17.6507 18.4075 16.4978 18.4075H3.27738C2.12452 18.4075 1.18994 17.4729 1.18994 16.3201V3.09964C1.18994 1.94678 2.12452 1.01221 3.27738 1.01221Z",
    stroke: "#003A9B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.8876 5.84424C12.0225 5.84424 13.7532 7.57494 13.7532 9.70986C13.7532 11.8448 12.0225 13.5755 9.8876 13.5755C7.75267 13.5755 6.02197 11.8448 6.02197 9.70986C6.02197 7.57494 7.75267 5.84424 9.8876 5.84424Z",
    stroke: "#003A9B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_5468"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.3281,
    height: 19.3281,
    fill: "white",
    transform: "translate(0.21875 0.046875)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResourcesDropdownIcon2);
export default __webpack_public_path__ + "static/media/resources-dropdown-icon-2.81a9fd7c981e9246a7b67d672c1827d0.svg";
export { ForwardRef as ReactComponent };